import { atomWithReset } from 'jotai/utils';

export interface FindPwState {
  step1: {
    value: string;
    firstName: string;
    lastName: string;
    code: string;
  };
  authMethods: any[];
  step2: {
    findWay: string;
    value: string;
  };
  step3: {
    value: string;
    token: string;
    fullPhoneNumber: string;
  };
  loginId: string;
  authState: boolean;
  certiNumber: string;
  password: string;
}

export const state = atomWithReset<FindPwState>({
  step1: {
    value: '',
    firstName: '',
    lastName: '',
    code: '',
  },
  authMethods: [],
  step2: {
    findWay: '',
    value: '',
  },
  step3: {
    value: '',
    token: '',
    fullPhoneNumber: '',
  },
  loginId: '',
  authState: false,
  certiNumber: '',
  password: '',
});
